import React from 'react';
import { Image } from 'views/components/atoms/Image';
import { Color, Radius } from 'views/constants';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

// Avatarは固定サイズにする
const IMAGE_SIZE = '36px';
const ImageWrapper = styled.div`
  width: ${IMAGE_SIZE};
  height: ${IMAGE_SIZE};
`;

const LabelWrapper = styled.div`
  margin-left: 8px;
`;

interface AvatarProps {
  src: string;
  name?: string;
  label?: React.ReactNode;
}

export const Avatar: React.FC<AvatarProps> = ({ src, name, label }) => {
  return (
    <Wrapper>
      <ImageWrapper>
        <Image
          src={src}
          alt={name}
          border={{
            width: '1px',
            color: Color.C14,
            radius: Radius.CIRCLE,
            style: 'solid',
          }}
        />
      </ImageWrapper>
      {label ? <LabelWrapper>{label}</LabelWrapper> : null}
    </Wrapper>
  );
};
